module.exports = __webpack_public_path__ + "files/3d05b4813749522ca657e9f8f7bcdc79.png";